import { useEffect, useState } from "react";
import "./type.css";
import { FaPencilAlt } from "react-icons/fa";
import { FaLandmark } from "react-icons/fa";
import { FaUser } from "react-icons/fa";





const TypeButtons = ({accountTypeString, setAccountTypeString,isErrors}) => {

    const [selectedAccountType, setSelectedAccountType] = useState([false,false,false]);

    const onClickAccountType = (item) =>{
        let items = [false,false,false]
        let account_type = "";
        switch(item){
            case 0:
                items = [true,false,false]
                account_type = "Hobbyist";
                setAccountTypeString(account_type)
                break;
            case 1:
                items = [false,true,false]
                account_type = "Professional";
                setAccountTypeString(account_type)
                break;
            case 2:
                items = [false,false,true]
                account_type = "Personal";
                setAccountTypeString(account_type)
                break;
            default:
                break
        }

        setSelectedAccountType(items)
    }


    return(
        <>
            <div>
                <button onClick={() => onClickAccountType(0)} className={accountTypeString !== undefined &&accountTypeString === "Hobbyist"?"type_container_button_selected":selectedAccountType[0]?"type_container_button_selected":"type_container_button"}>
                    <div className=""><FaPencilAlt /></div>
                    <div className="">Hobbyist</div>  
                </button>
                <button onClick={() => onClickAccountType(1)} className={accountTypeString !== undefined &&accountTypeString === "Professional"?"type_container_button_selected":selectedAccountType[1]?"type_container_button_selected":"type_container_button"}><FaLandmark /> Professional</button>
                <button  onClick={() => onClickAccountType(2)}className={accountTypeString !== undefined &&accountTypeString === "Personal"?"type_container_button_selected":selectedAccountType[2]?"type_container_button_selected":"type_container_button"}><FaUser /> Personal</button>
                {isErrors[1]&& <div className="error-label">Error: Please Selects an account type.</div>}
            </div>
            
        </>
    )
}

export default TypeButtons;